(() => {
  if (window.SSProductCompareReady) return;
  window.SSProductCompareReady = true;

  const STORAGE_KEY = 'ss_compare_products_v1';
  const MAX_PRODUCTS = 3;
  const CARD_SELECTOR = [
    '.product-card-wrapper',
    '.ss-product-card',
    '[data-product-card]'
  ].join(',');

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.slice(0, MAX_PRODUCTS) : [];
    } catch (_) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (_) {}
  }

  function product(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const url = new URL(link.href, location.href);
    const handle = url.pathname.match(/\/products\/([^/?#]+)/)?.[1];
    if (!handle) return null;
    const image = card.querySelector('.card__media img,.ss-product-card__image img,img');
    const title =
      card.querySelector('.card__heading,.ss-product-card__title,[class*="product-title"]')?.textContent?.trim() ||
      link.textContent.trim();

    return {
      handle,
      title,
      url: url.pathname,
      image: image?.currentSrc || image?.src || ''
    };
  }

  const drawer = document.createElement('aside');
  drawer.className = 'ss-compare-drawer';
  drawer.setAttribute('aria-label', 'Selected products for comparison');
  drawer.innerHTML = `
    <div class="ss-compare-drawer__inner">
      <div class="ss-compare-drawer__heading">
        <strong>Compare products</strong>
        <span data-compare-count>0/${MAX_PRODUCTS}</span>
      </div>
      <div class="ss-compare-drawer__items" data-compare-items></div>
      <div class="ss-compare-drawer__actions">
        <button type="button" data-compare-clear>Clear</button>
        <button type="button" data-compare-open>Compare Now</button>
      </div>
    </div>
  `;

  const modal = document.createElement('div');
  modal.className = 'ss-compare-modal';
  modal.hidden = true;
  modal.innerHTML = `
    <div class="ss-compare-modal__backdrop" data-compare-close></div>
    <section class="ss-compare-modal__dialog" role="dialog" aria-modal="true" aria-label="Product comparison">
      <header>
        <div>
          <span>SEATING SOLUTION</span>
          <h2>Product Comparison</h2>
        </div>
        <button type="button" data-compare-close aria-label="Close comparison">×</button>
      </header>
      <div class="ss-compare-modal__content" data-compare-content></div>
    </section>
  `;

  document.body.append(drawer, modal);

  const itemArea = drawer.querySelector('[data-compare-items]');
  const count = drawer.querySelector('[data-compare-count]');
  const compareButton = drawer.querySelector('[data-compare-open]');
  const content = modal.querySelector('[data-compare-content]');

  function toast(message) {
    let element = document.querySelector('.ss-compare-toast');
    if (!element) {
      element = document.createElement('div');
      element.className = 'ss-compare-toast';
      document.body.appendChild(element);
    }
    element.textContent = message;
    element.classList.remove('is-visible');
    void element.offsetWidth;
    element.classList.add('is-visible');
    clearTimeout(element.timer);
    element.timer = setTimeout(() => element.classList.remove('is-visible'), 1800);
  }

  function syncCardButtons(items) {
    document.querySelectorAll('[data-compare-handle]').forEach((button) => {
      const selected = items.some((item) => item.handle === button.dataset.compareHandle);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
      button.querySelector('span').textContent = selected ? 'Added' : 'Compare';
    });
  }

  function renderDrawer() {
    const items = read();
    count.textContent = `${items.length}/${MAX_PRODUCTS}`;
    drawer.classList.toggle('is-visible', items.length > 0);
    compareButton.disabled = items.length < 2;
    itemArea.innerHTML = items.map((item) => `
      <div class="ss-compare-chip">
        ${item.image ? `<img src="${item.image}" alt="">` : ''}
        <span>${item.title}</span>
        <button type="button" data-remove-compare="${item.handle}" aria-label="Remove ${item.title}">×</button>
      </div>
    `).join('');
    syncCardButtons(items);
  }

  function toggle(item) {
    const items = read();
    const index = items.findIndex((saved) => saved.handle === item.handle);
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      if (items.length >= MAX_PRODUCTS) {
        toast('You can compare up to 3 products');
        return;
      }
      items.push(item);
      toast('Added to comparison');
    }
    write(items);
    renderDrawer();
  }

  function setup(card) {
    if (card.dataset.ssCompareReady || card.closest('#SSProductQuickView,cart-drawer,cart-notification,.related-products')) return;
    const item = product(card);
    if (!item) return;
    card.dataset.ssCompareReady = 'true';
    card.classList.add('ss-compare-card');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ss-compare-toggle';
    button.dataset.compareHandle = item.handle;
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = '<i aria-hidden="true">⇄</i><span>Compare</span>';
    card.appendChild(button);
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggle(item);
    });
    syncCardButtons(read());
  }

  async function fetchDetails(item) {
    try {
      const response = await fetch(`/products/${item.handle}.js`);
      if (!response.ok) throw new Error();
      const data = await response.json();
      const available = data.variants?.some((variant) => variant.available);
      const prices = data.variants?.map((variant) => Number(variant.price)) || [0];
      return {
        ...item,
        title: data.title || item.title,
        image: data.featured_image || item.image,
        vendor: data.vendor || '—',
        type: data.type || '—',
        price: Math.min(...prices),
        available
      };
    } catch (_) {
      return { ...item, vendor: '—', type: '—', price: null, available: null };
    }
  }

  function money(value) {
    if (value === null) return 'View product';
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(value / 100);
    } catch (_) {
      return `₹${value / 100}`;
    }
  }

  async function openComparison() {
    const selected = read();
    if (selected.length < 2) return;
    modal.hidden = false;
    document.body.classList.add('ss-compare-locked');
    content.innerHTML = '<div class="ss-compare-loading"><span></span><p>Building comparison…</p></div>';
    requestAnimationFrame(() => modal.classList.add('is-open'));
    const products = await Promise.all(selected.map(fetchDetails));
    const columns = `repeat(${products.length}, minmax(210px, 1fr))`;
    content.innerHTML = `
      <div class="ss-compare-table" style="--compare-columns:${columns}">
        <div class="ss-compare-row ss-compare-products">
          ${products.map((item, index) => `
            <article style="--compare-delay:${index * 90}ms">
              <div class="ss-compare-product-image">${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}</div>
              <h3>${item.title}</h3>
              <strong>${money(item.price)}</strong>
            </article>
          `).join('')}
        </div>
        ${[
          ['Brand', (item) => item.vendor],
          ['Product type', (item) => item.type],
          ['Availability', (item) => item.available === null ? 'Check product' : item.available ? 'In stock' : 'Sold out']
        ].map(([label, value]) => `
          <div class="ss-compare-spec">
            <b>${label}</b>
            <div style="--compare-columns:${columns}">
              ${products.map((item) => `<span>${value(item)}</span>`).join('')}
            </div>
          </div>
        `).join('')}
        <div class="ss-compare-row ss-compare-links">
          ${products.map((item) => `<a href="${item.url}">View Product</a>`).join('')}
        </div>
      </div>
    `;
  }

  function closeComparison() {
    modal.classList.remove('is-open');
    document.body.classList.remove('ss-compare-locked');
    setTimeout(() => {
      modal.hidden = true;
      content.innerHTML = '';
    }, 260);
  }

  itemArea.addEventListener('click', (event) => {
    const handle = event.target.closest('[data-remove-compare]')?.dataset.removeCompare;
    if (!handle) return;
    const items = read().filter((item) => item.handle !== handle);
    write(items);
    renderDrawer();
  });

  drawer.querySelector('[data-compare-clear]').addEventListener('click', () => {
    write([]);
    renderDrawer();
  });
  compareButton.addEventListener('click', openComparison);
  modal.querySelectorAll('[data-compare-close]').forEach((button) => button.addEventListener('click', closeComparison));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeComparison();
  });

  function scan(root = document) {
    const cards = root.matches?.(CARD_SELECTOR) ? [root] : Array.from(root.querySelectorAll?.(CARD_SELECTOR) || []);
    cards.forEach(setup);
  }

  const style = document.createElement('style');
  style.textContent = `
    .ss-compare-card{position:relative}.ss-compare-toggle{position:absolute;z-index:14;left:12px;bottom:12px;display:flex;align-items:center;gap:6px;min-height:36px;padding:0 12px;border:1px solid rgba(255,255,255,.75);border-radius:999px;background:rgba(255,255,255,.86);color:#171717;box-shadow:0 7px 22px rgba(0,0,0,.12);backdrop-filter:blur(12px);font:inherit;font-size:12px;font-weight:700;cursor:pointer;transition:.2s ease}.ss-compare-toggle:hover{transform:translateY(-2px)}.ss-compare-toggle.is-selected{color:#fff;background:#171717}.ss-compare-toggle i{font-style:normal;font-size:16px}.ss-compare-drawer{position:fixed;z-index:99980;right:0;bottom:0;left:0;padding:12px 18px;pointer-events:none;opacity:0;transform:translateY(110%);transition:.42s cubic-bezier(.22,1,.36,1)}.ss-compare-drawer.is-visible{pointer-events:auto;opacity:1;transform:none}.ss-compare-drawer__inner{width:min(1180px,100%);display:flex;align-items:center;gap:16px;margin:auto;padding:12px;border:1px solid rgba(255,255,255,.6);border-radius:18px;background:rgba(255,255,255,.92);box-shadow:0 20px 65px rgba(0,0,0,.24);backdrop-filter:blur(18px)}.ss-compare-drawer__heading{display:grid;min-width:130px}.ss-compare-drawer__heading span{font-size:12px;color:#777}.ss-compare-drawer__items{min-width:0;display:flex;flex:1;gap:8px;overflow:auto}.ss-compare-chip{min-width:150px;max-width:210px;display:grid;grid-template-columns:38px 1fr 24px;align-items:center;gap:7px;padding:6px;border-radius:10px;background:#f4f1ee}.ss-compare-chip img{width:38px;height:38px;object-fit:contain}.ss-compare-chip span{overflow:hidden;font-size:11px;white-space:nowrap;text-overflow:ellipsis}.ss-compare-chip button{border:0;background:transparent;font-size:18px;cursor:pointer}.ss-compare-drawer__actions{display:flex;gap:8px}.ss-compare-drawer__actions button{min-height:42px;padding:0 16px;border:1px solid #171717;border-radius:10px;background:#fff;font:inherit;font-weight:700;cursor:pointer}.ss-compare-drawer__actions [data-compare-open]{color:#fff;background:#171717}.ss-compare-drawer__actions button:disabled{opacity:.4;cursor:not-allowed}.ss-compare-modal{position:fixed;inset:0;z-index:2147482000;display:grid;place-items:center;padding:20px}.ss-compare-modal[hidden]{display:none}.ss-compare-modal__backdrop{position:absolute;inset:0;background:rgba(8,10,14,.68);backdrop-filter:blur(8px);opacity:0;transition:.25s}.ss-compare-modal__dialog{position:relative;width:min(1180px,95vw);max-height:92vh;overflow:hidden;border-radius:20px;background:#fff;opacity:0;transform:translateY(35px) scale(.96);transition:.42s cubic-bezier(.22,1,.36,1)}.ss-compare-modal.is-open .ss-compare-modal__backdrop,.ss-compare-modal.is-open .ss-compare-modal__dialog{opacity:1}.ss-compare-modal.is-open .ss-compare-modal__dialog{transform:none}.ss-compare-modal__dialog>header{display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid #eee}.ss-compare-modal__dialog header span{font-size:10px;letter-spacing:.16em}.ss-compare-modal__dialog h2{margin:2px 0 0;font-size:24px}.ss-compare-modal__dialog header button{width:40px;height:40px;border:0;border-radius:50%;font-size:25px;cursor:pointer}.ss-compare-modal__content{max-height:calc(92vh - 78px);overflow:auto;padding:22px}.ss-compare-row{display:grid;grid-template-columns:var(--compare-columns);gap:12px}.ss-compare-products article{padding:15px;border:1px solid #eee;border-radius:15px;animation:ssCompareIn .55s cubic-bezier(.22,1,.36,1) var(--compare-delay) both}.ss-compare-product-image{height:210px;background:#f6f2ef;border-radius:12px}.ss-compare-product-image img{width:100%;height:100%;object-fit:contain}.ss-compare-products h3{font-size:15px}.ss-compare-spec{margin-top:14px;border-top:1px solid #eee}.ss-compare-spec>b{display:block;padding:11px 5px}.ss-compare-spec>div{display:grid;grid-template-columns:var(--compare-columns);gap:12px}.ss-compare-spec span{padding:12px;border-radius:9px;background:#f7f7f7}.ss-compare-links{margin-top:18px}.ss-compare-links a{padding:13px;border-radius:10px;color:#fff;background:#171717;text-align:center;text-decoration:none}.ss-compare-loading{min-height:350px;display:grid;place-content:center;justify-items:center}.ss-compare-loading span{width:38px;height:38px;border:3px solid #ddd;border-top-color:#171717;border-radius:50%;animation:ssCompareSpin .7s linear infinite}.ss-compare-toast{position:fixed;z-index:2147483000;left:50%;bottom:110px;padding:11px 17px;border-radius:999px;color:#fff;background:#171717;opacity:0;transform:translate(-50%,15px);transition:.25s}.ss-compare-toast.is-visible{opacity:1;transform:translate(-50%,0)}body.ss-compare-locked{overflow:hidden!important}@keyframes ssCompareIn{from{opacity:0;transform:translateY(25px) scale(.94)}to{opacity:1;transform:none}}@keyframes ssCompareSpin{to{transform:rotate(360deg)}}@media(max-width:749px){.ss-compare-toggle{left:8px;bottom:8px}.ss-compare-drawer{padding:7px}.ss-compare-drawer__inner{display:grid;grid-template-columns:1fr auto;gap:8px}.ss-compare-drawer__heading{display:flex;justify-content:space-between}.ss-compare-drawer__items{grid-column:1/-1;grid-row:2}.ss-compare-drawer__actions{grid-column:2;grid-row:1}.ss-compare-drawer__actions [data-compare-clear]{display:none}.ss-compare-modal{padding:7px}.ss-compare-modal__dialog{width:calc(100vw - 14px);max-height:calc(100vh - 14px)}.ss-compare-modal__content{padding:12px;overflow:auto}.ss-compare-table{min-width:660px}}@media(prefers-reduced-motion:reduce){.ss-compare-drawer,.ss-compare-modal__backdrop,.ss-compare-modal__dialog{transition:none!important}.ss-compare-products article{animation:none!important}}
  `;
  document.head.appendChild(style);
  scan();
  renderDrawer();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.documentElement, { childList: true, subtree: true });
})();
